import { Component, Input } from "@angular/core";
import { WizardStepComponent } from "./wizard-step.component";
@Component({
  selector: "icn-wizard-summary",
  templateUrl: "./wizard-summary.component.html",
  styleUrls: ["./wizard-summary.component.scss"],
})
export class WizardSummaryComponent {
  steps: WizardStepComponent[] = [];

  @Input()
  currentStepIndex: number;

  @Input()
  themeColor: "cyan" | "purple" = "purple";

  getIcon(step: WizardStepComponent) {
    const doneIcon = "/assets/icons/wiz-done-icon.svg";
    const vIcon = "/assets/icons/load-v-big.svg";

    if (
      this.currentStepIndex > step.stepIndex ||
      (this.currentStepIndex === step.stepIndex && step.isDoneStep)
    ) {
      return vIcon;
    }
    if (step.isDoneStep) {
      return doneIcon;
    }
    return step.icon;
  }
}
